"use client";

import {
    Trophy,
} from "lucide-react";
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import { useLanguage } from "@/components/LanguageContext";

export default function HaziVersenyekPage() {
    const {
        language,
    } = useLanguage();

    return (
        <main className="min-h-screen overflow-x-hidden bg-black font-sans">
            <Header />

            <section className="bg-[#dedede] text-black">
                <div className="mx-auto flex w-full max-w-[430px] flex-col items-center px-7 pb-16 pt-12 text-center md:max-w-5xl md:px-12 md:pb-24 md:pt-16">
                    <div
                        className="mb-6 flex shrink-0 items-center justify-center rounded-full border-[3px] border-black"
                        style={{
                            width: "80px",
                            height: "80px",
                            minWidth: "80px",
                            maxWidth: "80px",
                            minHeight: "80px",
                            maxHeight: "80px",
                            boxSizing: "border-box",
                        }}
                    >
                        <Trophy
                            style={{
                                width: "40px",
                                height: "40px",
                            }}
                            strokeWidth={2.5}
                        />
                    </div>

                    <h1 className="text-[25px] font-black lowercase leading-none md:text-[48px]">
                        {language === "en"
                            ? "house tournaments"
                            : "házi versenyek"}
                    </h1>

                    <p className="mt-8 max-w-[310px] text-[15px] leading-[1.25] text-neutral-700 md:max-w-xl md:text-[21px] md:leading-[1.4]">
                        {language === "en"
                            ? "test your skills against other players and see where you stand."
                            : "mérd össze a tudásodat más játékosokkal, és mutasd meg, mire vagy képes."}
                    </p>

                    <div className="mt-12 w-full max-w-[650px] border-[3px] border-black bg-[#f2f2f2] px-6 py-10 md:mt-16 md:px-12 md:py-14">
                        <p className="text-[12px] font-black lowercase tracking-[0.18em] text-neutral-500 md:text-[14px]">
                            {language === "en"
                                ? "currently"
                                : "jelenleg"}
                        </p>

                        <h2 className="mt-4 text-[22px] font-black lowercase leading-[1.1] md:text-[34px]">
                            {language === "en" ? (
                                <>
                                    no active house
                                    <br />
                                    tournament
                                </>
                            ) : (
                                <>
                                    jelenleg nem fut
                                    <br />
                                    házi verseny
                                </>
                            )}
                        </h2>

                        <p className="mx-auto mt-6 max-w-[310px] text-[15px] leading-[1.4] text-neutral-700 md:max-w-lg md:text-[19px] md:leading-[1.5]">
                            {language === "en"
                                ? "there is currently no announced house tournament. when a new tournament is scheduled, you'll find the date, details and all important information on this page."
                                : "jelenleg nincs meghirdetett házi verseny. amikor új verseny indul, ezen az oldalon megtalálod majd az időpontot, a részleteket és minden fontos információt."}
                        </p>

                        <div className="mx-auto mt-8 h-[3px] w-12 bg-black md:mt-10 md:w-16" />
                    </div>
                </div>
            </section>

            <Footer />
        </main>
    );
}